import { render, staticRenderFns } from "./actionmodal.vue?vue&type=template&id=13b8973c&scoped=true&"
import script from "./actionmodal.vue?vue&type=script&lang=js&"
export * from "./actionmodal.vue?vue&type=script&lang=js&"
import style0 from "./actionmodal.vue?vue&type=style&index=0&id=13b8973c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b8973c",
  null
  
)

export default component.exports